import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import {ReactBaseComponent} from '../../../react/base/react-base.component';
import {ManualPriceIncrease} from '../../../react/price/manual-price-increase';
import {PriceHistory} from '../price.models';

const containerElementName = 'reactManualPriceIncreaseSingleContainer';

@Component({
  selector: 'price-detail-manual-increase-single',
  template: `<div class="inline-block" #${containerElementName}></div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PriceDetailManualIncreaseSingleComponent extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  @Input() oaNr: string;
  @Input() price: PriceHistory;
  @Output() updated: EventEmitter<void> = new EventEmitter<void>();

  constructor(private ngZone: NgZone) {
    super();
  }

  onUpdated(): void {
    this.ngZone.run(() => {
      this.updated.emit();
    });
  }

  protected override renderComponent() {
    return <ManualPriceIncrease oaNr={this.oaNr}
                                price={this.price}
                                labelButton="Preis erhöhen"
                                onUpdated={() => this.onUpdated()} />;
  }
}
